import FormSection from 'components/shared/Form/FormSection';
import FormStep from 'components/shared/Form/FormStep';
import { useFetchDealTypes, useFetchStages } from '../hooks';
import { useFetchAutocompleteDropdowns } from '../useFetchAutocompleteDropdowns';
import { sections } from './data';

const Step1 = () => {
  const { businesses, clients, owners } = useFetchAutocompleteDropdowns();
  const map = {
    accountId: clients,
    businessId: businesses,
    ownerId: owners,
  };
  const { dealTypes } = useFetchDealTypes();
  const { stages } = useFetchStages();

  return (
    <FormStep>
      {sections.map((section) => {
        const { title, Component, fields } = section;

        return (
          <FormSection title={title} key={title}>
            <Component
              autocompleteMap={map}
              fields={fields ?? []}
              dropdowns={{
                dealType: dealTypes,
                stageName: stages,
              }}
            />
          </FormSection>
        );
      })}
    </FormStep>
  );
};

export default Step1;
